import { Global } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../../components/SeoHead";
import MainBanner from "../../../components/MainBanner";
import MultiColumnCTAWithDivider from "../../../components/MultiColumnCTAWithDivider";
import NewColumnWithForm from "../../../components/NewColumnWithForm";
import AccordionColumnBox from "../../../components/AccordionColumnBox";

export default function CandidateFAQPage({ global }) {
  const faqItems = [
    {
      title: "Locked account",
      content:
        'If your InTime account is locked please email the <a href="mailto:ask@impellam.com?subject=Locked%20Account">ASK Team</a>. If your employer/client account is locked you will need to contact them directly.',
    },
    {
      title: "Need a copy of your P45 or P60",
      content:
        "If you're part of an umbrella or PAYE? Email the <a href=\"mailto:PAYE@lorienglobal.com?subject=PAYE%20Enquiry\">PAYE Team</a>. If you're a limited company you will need to go to HMRC or your accountant.",
    },
    {
      title: "Timesheet enquiries or issues",
      content:
        'Timesheets must be filled out every Friday and submitted to your manager by the following Monday. Any other questions please <a href="mailto:ask@impellam.com?subject=Timesheet%20enquiry">contact your consultant via email</a> or <a href="tel:02076541000">phone</a>.',
    },
    {
      title: "References",
      content:
        'If you\'re looking for a reference either for yourself or as an employer, please contact the <a href="mailto:ask@impellam.com?subject=Reference%20request">ASK Team</a>.',
    },
    {
      title: "Want to know more information on a live role",
      content:
        'Please get in touch by <a href="mailto:info@lorienglobal.com?subject=Information%20request%20about%20a%20role">sending the job title and/or link to the advert via email</a> or tell us over the <a href="tel:02076541000">phone</a>.',
    },
    {
      title: "Update on an existing application",
      content:
        'Please contact the consultant dealing with the role directly or if this is not known <a href="mailto:info@lorienglobal.com?subject=Update%20on%20a%20job%20application">get in touch via email</a> or <a href="tel:02076541000">phone</a>.',
    },
    {
      title: "Provide an updated CV",
      content:
        'If you have previously worked with a Lorien consultant please send it directly to them, if not please <a href="mailto:info@lorienglobal.com?subject=CV%20Update">send it here</a>.',
    },
  ];

  return (
    <>
      <SeoHead
        page_name={`Candidate FAQ | The global house of tech and transformation recruitment | Lorien`}
        canonical_link={`about-us/candidate-faq`}
      />
      <MainBanner
        global={global}
        pathPrefix={`candidate_faq_page.main_banner`}
        customClass={``}
        content={
          <>
            <h1>Candidate FAQ</h1>
            <p>
              Are you a candidate and have a question for us? Check below for
              our frequently asked questions for our top candidate enquiries to
              streamline the job application process for all candidates. From
              application updates to locked accounts, you can find your answer
              here.
            </p>
          </>
        }
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/sub-banner-job-seekers.png`}
        imageALT2={`Overlay Main Banner`}
        displayImage1={false}
        breadcrumb_title="Candidate FAQs"
        secondary_breadcrumb_url={"/job-seekers"}
        secondary_breadcrumb_title={"Job Seekers"}
      />
      <AccordionColumnBox
        global={global}
        pathPrefix="candidate_faq_page.faq_section"
        customClass="my-5"
        post={faqItems}
      />
      <NewColumnWithForm 
        formId={`308d12ba-6cc4-44a5-91e2-76d1d714bf23`}

        successPageUrl={`/about-us/join-us/submission-success`}
      />
      {/* <MultiColumnCTAWithDivider
        global={global}
        pathPrefix={`join_us_page.multi_column_cta`}
        customClass={`pt-5 pb-md-4 pb-5`}
        left_content={
          <>
            <h2>Get in Touch</h2>
          </>
        }
        right_content={
          <>
            <h2>Newsletter Sign up</h2>
          </>
        }
        buttonLink2={`/`}
        buttonLink1={`/contact-us/`}
        buttonTitle1={`Contact us`}
        buttonTitle2={`For Candidates`}
        buttonLink2_1={`/`}
        buttonTitle2_1={`For Clients`}
        popUpModal_1={true}
        popUpModal_2={true}
        popUpModal_1_form_id={`929d2abe-c9a8-4d0d-a095-6092219c35a1`}
        popUpModal_2_form_id={`1563f130-d045-4cbb-89ba-b83d6738c2db`}
        dialog_content_1={<h5>For candidates</h5>}
        dialog_content_2={<h5>For clients</h5>}
        successPageUrl={`/about-us/join-us/submission-success`}
      /> */}
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();

  return {
    props: {
      global,
    },
  };
}
